
export class OpWiseSummaryQtyModel {
    opCode: string;
    opCategory: string;
    totalQuantityTillDate: number;
    totalQuantityToday: number;
    wipQty: number;
  
    constructor(
      opCode: string,
      opCategory: string,
      totalQuantityTillDate: number,
      totalQuantityToday: number,
      wipQty: number
    ) {
      this.opCode = opCode;
      this.opCategory = opCategory;
      this.totalQuantityTillDate = totalQuantityTillDate;
      this.totalQuantityToday = totalQuantityToday;
      this.wipQty = wipQty;
    }
  }